export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter();

  // Watch for route changes and update Pendo context
  router.afterEach((to, from) => {
    setTimeout(async () => {
      // Helper function to extract page context dynamically from path
      const getPageContext = (path: string) => {
        const [pageType, contextId] = path.split("/").filter(Boolean);
        return { pageType, contextId };
      };

      const fromContext = getPageContext(from?.path || "");
      const toContext = getPageContext(to.path);

      // Clear context and pendo data cache if page type OR context ID changed
      const shouldClearContext =
        fromContext.pageType !== toContext.pageType || (fromContext.pageType === toContext.pageType && fromContext.contextId !== toContext.contextId);

      if (shouldClearContext) {
        const { getCurrentContext, getPendoMetadata } = usePendo();
        getCurrentContext.clear();
        getPendoMetadata.clear(); // Clear combined data since context changed
      }

      const { $updatePendoContext } = useNuxtApp();
      if ($updatePendoContext) {
        await $updatePendoContext();
      }
    }, 100);
  });
});
